import { Product } from '@futrli-sdk/app-store';
import {
  CreateCustomer as CreateCustomerSDK,
  Intent,
  PaymentDetails,
  PaymentIntentCreate as PaymentIntentCreateSDK,
  SubscriptionTerm
} from '@futrli-sdk/billing';
import { AnyObject, LoadingRequestState, NormalisedData } from '@futrli/shared-services';

export enum StripeComponentInputType {
  input = 'input',
  select = 'select'
}

export type BillingProduct = Pick<Product, 'name' | 'slug'>;

export interface Dialog {
  header: JSX.Element;
  content: JSX.Element;
}

export interface IntentActions {
  createIntent: (paymentMethodId?: string) => Promise<Intent | undefined>;
  handleIntent: (intentId: string) => Promise<Intent | undefined>;
}

export interface PaymentIntentCreate extends Omit<PaymentIntentCreateSDK, 'payment_method_id'> {
  payment_method_id?: string;
}

export interface CreateCustomer extends Omit<CreateCustomerSDK, 'billing_address'> {
  billing_address: Partial<PaymentDetails['billing_address']>;
}

export type BillingTerm = keyof typeof SubscriptionTerm;

export interface StoreState {
  normalised: NormalisedData<unknown>;
  loadingRequests: LoadingRequestState;
  intlReducer: AnyObject;
}
